<template>
  <div class="body">
    <div class="tabs">
      <!-- <div :class="tabIndex == 3 ? 'active_item' : ''" @click="changeTab(3)" v-if="!userInfo.shop_id">职能</div> -->
      <div :class="tabIndex == 2 ? 'active_item' : ''" @click="changeTab(2)" v-if="!userInfo.shop_id">市场</div>
      <div :class="tabIndex == 1 ? 'active_item' : ''" @click="changeTab(1)" >门店</div>
    </div>
    <el-tabs type="card" v-model="activeName"    @tab-click="handleClick" v-if="tabIndex == 1">
      <el-tab-pane label="渠道维度" name="first"> 
        <shopData ref="shopRef" :tabIndex="tabIndex" />
      </el-tab-pane>
      <el-tab-pane label="护理师维度" name="second">
        <nurseData ref="nurseRef" :tabIndex="tabIndex" />
      </el-tab-pane>
    </el-tabs>      
    <div v-if="tabIndex == 2">
        <marketData ref="marketRef" :tabIndex="tabIndex" />
    </div>
     <div v-if="tabIndex == 3">
      <functionData ref="functionRef" :tabIndex="tabIndex" />
    </div>
  </div>
</template>

<script>
import  shopData  from './shopData.vue'
import  nurseData  from './nurseData.vue'
import  marketData  from './marketData.vue'
import  functionData  from './functionData.vue'

import { mapGetters } from "vuex";
import { lookLog } from '@/api/sys'

export default {
  components: {
    shopData,
    nurseData,
    marketData,
    functionData
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },

  data() {
    return {
      tabIndex: 1,
      activeName: 'first',

     
    }
  },
  created() {
    this.tabIndex = this.userInfo.shop_id ? 1 : 2
     lookLog({type:this.tabIndex}).then(res => {
        console.log(res)
      })
  },
  methods: {
    handleClick(tab, event) {
        this.activeName = tab.name
        this.$nextTick(() => {
          this.$refs.shopRef.handleResize(); 
          this.$refs.nurseRef.handleResize(); 
        });
    },

    changeTab(index){
      this.tabIndex = index
      this.activeName = 'first'
      lookLog({type:index}).then(res => {
        console.log(res)
      })
      if(index == 1){
        this.$nextTick(() => {
          this.$refs.shopRef.handleResize(); // 安全调用
          this.$refs.nurseRef.handleResize(); // 安全调用
        });
      }
   
    },
   
  }
}
</script>

<style lang="scss" scoped>

::v-deep .el-tabs__item.is-active{
  color: #33bea7;
}
.tabs {
  display: flex;
  justify-content: center;
  column-gap: 10ch;
  font-size: 23px;
  font-weight: 600;
  div {
    cursor: pointer;
    position: relative;
    &::after {
      content: ''; // 必须设置content属性
      position: absolute;
      bottom: -10px;
      left: 0;
      width: 100%; // 宽度与选项卡标签一致
      height: 3px;
      background-color: #33bea7;
      transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      transform-origin: left;
      transform: scaleX(0); // 默认不显示
    }
  }
  
  .active_item {
    color: #33bea7; // 只保留文字颜色变化
    border-bottom: none; // 移除border-bottom
    /* 显示高亮指示器 */
    &::after {
      transform: scaleX(1); // 完全显示
    }
  }
}
.body{
  width: 100%;
  box-sizing: border-box;
  padding:1% 2%;
  background:rgba(237, 242, 255,0.4);
  // background: rgba(51, 190, 167,0.4);
  // background: rgba(105, 177, 255,0.3);
  border: 0.12rem dashed  #33bea7;

  background-size: 100% 100%;
}

</style>
